<form [formGroup]="changePriceForm" novalidate (ngSubmit)="changePriceForm.valid && confirm()">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Cambiar precio</h4>
      <button type="button" class="close" (click)="cancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="discountValue"><b>Valor</b></label>
        <div class="col-md-9">
          <input id="discountValue" name="discountValue" type="text" class="form-control" mask="separator.2"
            thousandSeparator="," formControlName="discountValue"
            [class.is-invalid]="(changePriceForm.get('discountValue')?.touched || changePriceForm.get('discountValue')?.dirty) && changePriceForm.get('discountValue')?.invalid">

        </div>
      </div>
    </div>
    <div class="modal-footer">

      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
      <button type="submit" class="btn btn-outline-primary">Confirmar</button>
    </div>
  </div>
</form>